import { useDataState } from '../providers/DataProvider/DataContext';
export const useValidTopic = (topics = []) => {
  const availableTopics = useDataState().topicState.topics;
  const topicUrns = topics.map(topic => topic.urn);
  return availableTopics.find(availableTopic => topicUrns.includes(availableTopic.urn));
};